<template>
  <v-card>
    <v-card-text>
      <v-row justify="space-between" align="center">
        <v-col :cols="pdfMode ? 3 : undefined">
          <div>
            <small> <b>{{ $tc('contract.name', 1) }}: </b> </small>
            <span> {{contract.contractName}} </span>
          </div>
          <div>
            <small> <b>{{ $tc('contract.package', 1) }}: </b> </small>
            <span> {{contract.package}} </span>
          </div>
          <div>
            <small> <b>{{ $tc('contract.contractor', 1) }}: </b> </small>
            <span> {{contract.contractor.companyName}}</span>
          </div>
        </v-col>
        <v-col class="text-h6 font-weight-bold text-center nowrap">
          <v-row v-if="editName" align="center">
            <v-text-field
              v-model="localName"
              dense
              outlined
              hide-details
              :label="$t('common.name')"
            />
            <v-btn small color="primary" class="mx-2" outlined rounded @click="handleCancel">
              {{ $t('common.cancel') }}
            </v-btn>
            <v-btn small color="primary" rounded @click="handleSave">
              {{ $t('common.save') }}
            </v-btn>
          </v-row>
          <v-row v-else-if="pdfMode" class="pdf-center">
            <h1>
              {{ item.name || $t('reports.reportHeader.reportFor', { value: titleDate }) }}
            </h1>
          </v-row>
          <v-row v-else align="center" justify="center">
            {{ item.name || $t('reports.reportHeader.reportFor', { value: titleDate }) }}
            <v-btn
              icon
              small
              @click="handleEditTitle"
              class="ml-2"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-row>
        </v-col>
        <v-col :class="['text-end']" :cols="pdfMode ? 3 : undefined">
          <div>
            <small> <b>{{ $tc('contract.signatureDate', 1) }}: </b> </small>
            <span> {{contract.signatureDate | formatDate}}</span>
          </div>
          <div>
            <small> <b>{{ $tc('contract.contractManager', 1) }}: </b> </small>
            <div> {{contractManager}}</div>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import dayjs from 'dayjs'
import { getUser } from '@/services'

export default {
  name: 'ReportHeader',
  props: {
    contract: {
      type: Object
    },
    item: {
      type: Object
    },
    pdfMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      editName: false,
      contractManager: '',
      localName: ''
    }
  },
  computed: {
    titleDate () {
      return dayjs(this.item.createdAt).format('MMMM YYYY')
    }
  },
  async mounted () {
    const contractManager = await getUser(this.contract.contractManager)
    this.contractManager = contractManager.displayName
  },
  methods: {
    handleCancel () {
      this.editName = false
      this.localName = ''
    },
    handleSave () {
      this.$emit('save', { name: this.localName })
      this.editName = false
      this.localName = ''
    },
    handleEditTitle () {
      this.editName = !this.editName
      this.localName = this.item.name
    }
  }
}
</script>

<style scoped>
.pdf-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.text-align-center {
  text-align: center;
}

.text-end {
  text-align: end;
}
</style>
